import { Div } from "@tblabs/truffle";
import { InfoBox } from "../Components/InfoBox";
import { LoaderSpinner } from "../Components/LoaderSpinner";
import { PrimaryButton } from "../Components/PrimaryButton";


export class Page extends Div
{
    public body: Div;
    private loader = new LoaderSpinner("Ładowanie strony...");

    constructor(private pageTitle: string)
    {
        super();
        this.Class("page");
        this.PaddingBottom(48).PaddingTop(32)

        document.title = this.pageTitle;

        this.body = new Div("").Style(`padding: 16px; padding-top: 0; max-width: 800px; margin: 0 auto;`);

        this.Append(
            new Div("content")
                .Append(
                    new Div("").Append(
                        this.body
                    )),
        );
    }

    protected async Content(content: (body: Div) => Promise<void>): Promise<void>
    {
        try
        {
            this.Append(
                this.loader,
            )

            await content(this.body);
        }
        catch (ex: any)
        {
            console.error('[Page] Exception:', ex);

            let messageHeader = "Error";
            let messageBody = ex.message;
            const msg = ex.message.toLowerCase();
            
            if (msg.includes("unauthorized"))
            {
                messageHeader = "Unauthorized";
                messageBody = "You are not supposed to be here...";
            }
            else if (msg.includes("failed to fetch"))
            {
                messageHeader = "Connection problem";
                messageBody = "Check your connection and try again";
            }
           
            this.body.Append(
                new InfoBox(messageHeader, messageBody),
                new PrimaryButton("Login").OnClick(() => window.location.href = "#login"),
                new PrimaryButton("Home").OnClick(() => window.location.href = "/").MarginLeft(12),
            );
        }
        finally
        {
            this.loader.RemoveSelf();
        }
    }
}
